import { Box, Button, IconButton, Typography } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'; import { OrderModel } from "../../models/order";
import { CartsModel } from "../../models/carts";
import { useTranslation } from "react-i18next";
import LinearProgressBar from "../../components/LinearProgressBar";
import usePackOrderController from "./controller/PackOrderController";
import ReadyToShip from "./ReadyToShip";
import DetailPackOrder from "./components/DetailPackOrder";
import CardPackProduct from "./components/CardPackProduct";
interface Props {
    onClose: VoidFunction,
    selectedData: OrderModel,
    onRefetchData: () => Promise<void>;
    onCloseFormDetail: VoidFunction,
    oriCarts: CartsModel[]
}

const PackOrder = ({ onClose, selectedData, onRefetchData, onCloseFormDetail, oriCarts }: Props) => {
    const { t } = useTranslation("global");
    const controller = usePackOrderController({
        selectedData
    });
    console.log(selectedData);

    if (controller.isReadyToShip) return <ReadyToShip currentTotalWithDeliveryFee={controller.totalCurrentOrder()} oriCarts={oriCarts} currentCarts={controller.carts} selectedData={selectedData} onClose={controller.handleCloseIsReadyToShip} onCloseFormDetail={onCloseFormDetail} onRefetchData={onRefetchData} />

    return <>
        <Box>
            <IconButton onClick={onClose} sx={{ mb: 2 }}>
                <KeyboardBackspaceIcon />
            </IconButton>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, width: '100%', justifyContent: 'space-between' }}>
                <Typography color="#737373" fontSize="32px" fontWeight='bold'>{t("order_page.Packing order")}</Typography>
                <Typography color="#737373" fontSize="32px">{t("order_page.Order ID")}: {selectedData?.orderNo}</Typography>
            </Box>
            <Box sx={{ maxWidth: 1200, }}>
                <Box sx={{ mt: 2 }}>
                    <LinearProgressBar value={controller.handleCalculatePercentProgressBar()} />
                </Box>

                <CardPackProduct
                    selectedData={selectedData}
                    carts={controller.carts}
                    onMinusProduct={controller.handleMinusProduct}
                    onPlusProduct={controller.handlePlusProduct}
                    onCheckAddedAllProduct={controller.handleCheckAddedAllProduct}
                    onPickProduct={controller.handlePickProduct}
                />

                <DetailPackOrder selectedData={selectedData} carts={controller.carts} calculateTotalWithDeliveryFeeSum={controller.calculateTotalWithDeliveryFeeSum} totalCurrentOrder={controller.totalCurrentOrder} />
                {
                    controller.carts.length > 0
                    &&
                    <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, mt: 2 }}>
                        <Button onClick={controller.handleOpenIsReadyToShip} variant="contained" color={controller.isFinishedPacking ? "primary" : "error"} sx={{ textTransform: 'none' }}>{t("order_page.Finish")}</Button>
                    </Box>
                }

            </Box>
        </Box>
    </>
}
export default PackOrder;